import React, { Component } from "react";
import { errorToaster } from "./../../helpers/utils";
import { getCommunityDetails } from "./../../crud/user-community.crud";
import Loading from "./../../components/Loading";
import Container from "./../../components/Container";
import CommunityDetails from "./CommunityDetails";
import CommunityEvents from "./CommunityEvents";
import UserCommunityHeader from "./UserCommunityHeader";

const eventStatus = ["ONGOING", "UPCOMING", "PAST"];

class UserCommunity extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: {},
			upcomingEvents: [],
			ongoingEvents: [],
			pastEvents: [],
			loading: true,
			error: false,
			limit: 8,
			offset: 0,
			communityUrl: this.props.router.query.communityUrl.toLowerCase()
		};
	}

	componentDidMount() {
		this.fetchData();
	}

	fetchData = async () => {
		try {
			let communityDetails, events;
			this.setState({ ...this.state, loading: true, error: false });
			communityDetails = await getCommunityDetails(this.state.communityUrl);
			this.setState({
				...this.state,
				loading: false,
				error: false,
				data: communityDetails.data.community_details,
				ongoingEvents: communityDetails.data.ongoing_events,
				upcomingEvents: communityDetails.data.upcoming_events,
				pastEvents: communityDetails.data.past_events
			});
		} catch (err) {
			this.setState({ ...this.state, loading: false, error: true });
			let error = err.message || "Something went wrong!";
			errorToaster(error);
		}
	};

	render() {
		return (
			<>
				<UserCommunityHeader />
				<div className="user-community-container py-4">
					<Container>
						{this.state.loading ? (
							<Loading className="w-100 text-center p-5" />
						) : (
							<>
								{this.state.error ? (
									<h4 className="text-center p-5 m-5">
										Looks like something went wrong! Please try again after
										sometime!
									</h4>
								) : (
									<>
										<CommunityDetails data={this.state.data} />
										{eventStatus.map(status => (
											<>
												{this.state[`${status.toLowerCase()}Events`]
													.length > 0 && (
													<CommunityEvents
														communityUrl={this.state.communityUrl}
														title={status}
														data={
															this.state[
																`${status.toLowerCase()}Events`
															]
														}
														limit={this.state.limit}
														offset={this.state.offset}
													/>
												)}
											</>
										))}
									</>
								)}
							</>
						)}
					</Container>
				</div>
				<style jsx>{`
					.user-community-container {
						background: #fff;
						font-family: "Nunito" !important;
					}
				`}</style>
			</>
		);
	}
}

export default UserCommunity;
